class r {
  constructor(t) {
    this.value = t;
  }
  toJSON() {
    return `$${this.value}`;
  }
}
export {
  r as VariableType
};
//# sourceMappingURL=VariableType.mjs.map
